module.exports = __webpack_public_path__ + "static/img/7.cf5d857.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/11/eng/7.png
// module id = 0D41
// module chunks = 0